import { render, staticRenderFns } from "./ExpiryNotificationConfirm.vue?vue&type=template&id=a05c4b14&scoped=true"
import script from "./ExpiryNotificationConfirm.vue?vue&type=script&lang=js"
export * from "./ExpiryNotificationConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05c4b14",
  null
  
)

export default component.exports